module.exports = [{
      plugin: require('F:/Websites/React/zkmsz-erettsegi-portal/node_modules/gatsby-plugin-material-ui/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
